import { z } from 'zod';

export type City = {
    id: number,
    name: string,
    created_at?: string,
};

export const CitySchema = z.object({
    id: z.number(),
    name: z.string(),
    created_at: z.string().nullable().optional(),
});
